import { render, staticRenderFns } from "./files-updown.vue?vue&type=template&id=97b2cc1c&"
import script from "./files-updown.vue?vue&type=script&lang=ts&"
export * from "./files-updown.vue?vue&type=script&lang=ts&"
import style0 from "./files-updown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports